module.exports = __webpack_public_path__ + "static/media/twitter.49224b0e.svg";